import * as Breadcrumbs from '../../components/breadcrumbs/types'
import * as Menu from '../../components/menu/left-nav'
import * as RasaInput from '../../components/rasa-input'
export const CUSTOM_DATE_RANGE = 'custom'

export const DateRangeFieldNames = {
  dateRange: 'dateRange',
  endDate: 'endDate',
  startDate: 'startDate',
}

export const CommunityFieldNames = {
  community: 'community',
}

export const SocialMediaTypes = {
  LinkedIn: 'linkedin',
  Twitter: 'twitter',
}

export const reportBreadcrumbs = (reportUrl: string): Breadcrumbs.Breadcrumbs => {
  return Menu.breadcrumbs(reportUrl)
}

export const ALL_CLICKS_KEY = 'all_clicks'
export const REAL_CLICKS_KEY = 'real_clicks'
export const ONLY_SUSPECT_CLICKS_KEY = 'suspect_clicks'

export const CLICK_TYPES: RasaInput.DropdownOption[] = [
  {
    description: 'All Clicks',
    key: ALL_CLICKS_KEY,
  },
  {
    description: 'Without Suspect Clicks',
    key: REAL_CLICKS_KEY,
  },
]



// WEBPACK FOOTER //
// ./src/pages/reports/constants.ts